import { create } from "zustand";

const STORAGE_KEY = "orders_sound_muted";

const readMuted = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch (error) {
    return false;
  }
};

/**
 * Preferência do alerta sonoro de novos pedidos (por navegador).
 * O Header toca o som; a Gestão de Pedidos liga/desliga.
 */
const useSoundStore = create((set) => ({
  muted: readMuted(),
  toggleMuted: () =>
    set((state) => {
      const muted = !state.muted;
      try {
        localStorage.setItem(STORAGE_KEY, muted ? "1" : "0");
      } catch (error) {
        // Sem storage: vale só para a sessão atual
      }
      return { muted };
    }),
}));

export default useSoundStore;
